import ModalButton from "../ModalButton";
import ModalContentWrapper from "../ModalContentWrapper";
import {validateMode} from "../modalFunctions";

import SpinnerDiv from "../../ui/ReactSpinnerDiv";

import {getPupilObservations} from "root/DataFunctions/ObservationFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getChildDataWithDetails} from "root/DataFunctions/ChildFns";

import {generateLearningJournalFromData} from "./LearningJournal";

import {naturalScriptBoldFont} from "root/pdf/fonts/naturalScriptBoldFont";
import {kristenFont} from "root/pdf/fonts/kristenFont";

import {LoadingStatus} from "./useLoadingDialog";

import {Globals} from "root/globals";

const pdf = require('../../pdf/pdf2.js');

export { ModalButton, ModalContentWrapper, LoadingStatus, validateMode, SpinnerDiv, Globals, getDataFromResponse, getPupilObservations, getChildDataWithDetails, generateLearningJournalFromData, naturalScriptBoldFont, kristenFont, pdf }